









import { Component, Vue } from 'vue-property-decorator'
import * as DateUtil from '@/tcw/utils/DateUtil'
import { CellClassParams } from 'ag-grid-community'
import * as tcw from '@/tcw/utils/TcwService'

interface KintaiJikanCellClassParams extends CellClassParams {
  type: 'plain' | 'info' | 'danger'
  optionString?: string
}

@Component
export default class GridCellKintaiJikan extends Vue {
  private params!: KintaiJikanCellClassParams

  get isEmpty(): boolean {
    return this.params.value === null || this.params.value === undefined || this.params.value === ''
  }

  get jikokuValue(): string {
    if (this.isEmpty) {
      return ''
    }
    if (typeof this.params.value === 'string') {
      const date = tcw.dateOf(this.params.value)
      return date ? DateUtil.convertDateToStr(date, 'HH:mm') : ''
    } else if (this.params.value instanceof Date) {
      return DateUtil.convertDateToStr(this.params.value, 'HH:mm')
    }
    return ''
  }
  get tagType(): string {
    const type = this.params.type
    return type ? `optional-tag-${type}` : ''
  }
  get optionString(): string | undefined {
    const optionString = this.params.optionString
    return optionString ? optionString : undefined
  }
}
